import React from 'react';
import PropTypes from 'prop-types';
import translations from 'Translations';
import LogoImage from 'Components/logo';

import './idle-screen.scss';

const IdleScreen = (props) => (
  <div className="idle-screen">
    <LogoImage />
    <div className="idle-screen__text">
      {translations[props.settings.APP_NAME].readytocast}
    </div>
  </div>
);

export default IdleScreen;

IdleScreen.propTypes = {
  settings: PropTypes.object.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/idle-screen/index.js